import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function fileMetricReducer(
  state = initialState.fileMetrics,
  action
) {
  switch (action.type) {
    case types.GET_TOTAL_FILES_UPLOADED_BY_MONTH:
      return {
        ...state.fileMetrics,
        totalFilesUploaded: action.metric,
        totalScoredUsersByMonth: state.totalScoredUsersByMonth,
      };
    case types.GET_TOTAL_SCORED_USERS_BY_MONTH:
      return {
        ...state.fileMetrics,
        totalScoredUsersByMonth: action.metric,
        totalFilesUploaded: state.totalFilesUploaded,
      };
    default:
      return state;
  }
}
